import React, { useState } from "react";
import { Button } from "../../../components/UI/button";
import { LoaderVectors } from "../../../constants/icons";
import { defaultLanguage } from "../../../constants/languages";
import callAPI from "../../../api";
import {
  generatePlaceholder,
  getOtpLength,
} from "../../../helpers/logic";
import { mapBackendError } from "../../../helpers/errorHandling";
import { useSystem } from "../../../hooks/use-system";
import OTPInput from "react-otp-input";
import { Input } from "../../../components/UI/input";

export default function InputCarrierForm({
  popUpText,
  config,
  language,
  setStep,
  verificationRequest,
  carrierCode,
}) {
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const system = useSystem();
  const otpLength = getOtpLength(config, carrierCode);

  const isOtpComplete = config?.otp_length
    ? otp.length === otpLength && !otp.includes("_")
    : otp.length > 0;
  const isTesting = config.is_testing;

  return (
    <div className="w-full max-w-md  flex flex-col justify-center items-center gap-2 mt-3">
      <div className="flex justify-center items-center w-full">
        <span
          className="text-sm"
          style={{
            color: config.text_color || "#000",
          }}
        >
          {config.texts?.[language || defaultLanguage]?.[1]?.button_caption ||
            ""}
        </span>
      </div>

      {popUpText && (
        <div
          className={`relative rounded-lg px-3 -mb-1 ${
            !isOtpComplete && config.animation_enabled
              ? "animate-[wiggle_1s_ease-in-out_infinite]"
              : ""
          }`}
        >
          <p
            className="text-sm text-center font-semibold m-0"
            style={{
              color: config.text_color || "#000",
            }}
            dangerouslySetInnerHTML={{ __html: popUpText }}
          ></p>
        </div>
      )}

      {config?.otp_length ? (
        <OTPInput
          value={otp}
          onChange={setOtp}
          numInputs={otpLength}
          placeholder={generatePlaceholder(otpLength, "_")}
          inputStyle={{
            width: "100%",
            height: "100%",
            maxWidth: 72,
            fontSize: 25,
            backgroundColor: "#E3E3E3",
          }}
          containerStyle={{
            gap: 10,
            height: 72,
          }}
          renderInput={(props) => <input {...props} />}
        />
      ) : (
        <Input
          className="text-xl bg-transparent border-gray-500"
          disabled={loading}
          placeholder="PIN"
          maxLength={8}
          onChange={(e) => setOtp(e.target.value)}
        />
      )}

      {error && (
        <div className="flex justify-center items-center w-full bg-[#FCEBE9] rounded-lg border-[#E02F1F] border-1">
          <div className={"text-[#e02f1fe3] my-2"}>{error || ""}</div>
        </div>
      )}

      <Button
        className={`af-btn flex flex-row gap-2 sm:h-[98px] h-[60px] landscape:h-[55px] px-5 py-4 landscape:py-1.5 landscape:px-4 w-full mt-3 ${
          loading ? "cursor-not-allowed " : "cursor-pointer "
        }  font-semibold text-xl md:text-3xl landscape:text-xl rounded-full tracking-wider ${
          isOtpComplete && config.animation_enabled
            ? "animate-[wiggle_1s_ease-in-out_infinite]"
            : ""
        }`}
        style={{
          backgroundColor: config.button_primary_color || "#e02f1fe3",
          color: config.button_text_color || "#000",
          fontSize: config.button_font_size,
        }}
        type="submit"
        disabled={loading || !isOtpComplete}
        onClick={() => {
          if (isTesting) {
            console.log("Testing OTP FLOW");
            setStep((prev) => prev + 1);
          } else {
            setLoading(true);
            callAPI(
              {
                verification_request: verificationRequest,
                code: otp,
                path: window.location.pathname,
                web_click_id: system.webClickId,
                config_id: system.config.public_id,
                language: system.language,
              },
              "verifyOTP"
            )
              .then((data) => {
                if (data.status !== "success") {
                  const supportedLanguage = config?.supported_languages ? Object.keys(config.supported_languages)[0] : null;
                  setError(mapBackendError(data.message, 'pin', supportedLanguage));
                  setLoading(false);
                  return;
                }

                window.location.href = data.payload.web_url;
              })
              .catch((e) => {
                setError("Network error. Please check your connection and try again.");
                setLoading(false);
              });
          }
        }}
      >
        {loading ? (
          <>
            <span className="animate-spin">
              <LoaderVectors />
            </span>
            <div className="flex flex-row justify-end items-center">
              <p className="m-0" style={{ fontSize: config.button_font_size }}>
                {
                  config.texts?.[language || defaultLanguage]?.[1]
                    .button_loading_text
                }
              </p>
              <span className="animate-bounce">.</span>
              <span className="animate-bounce delay-200">.</span>
              <span className="animate-bounce delay-300">.</span>
            </div>
          </>
        ) : (
          config.texts?.[language || defaultLanguage]?.[1]?.button_text || ""
        )}
      </Button>
    </div>
  );
}
